import { message } from "antd";

export function showErrorToast(e, fallbackMessage) {
  message.error(
    e.response.data?.message ||
      e.response.data?.msg ||
      e.response.data?.error ||
      fallbackMessage
  );
}
